// extracted by mini-css-extract-plugin
export default {"prefix-icon":"LoginForm_prefix-icon__JpzQE","login-button":"LoginForm_login-button__Ji-im"};